import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createProductUnit',
    serviceName: 'admin',
    query: gql`
      mutation createProductUnit($title: String!) {
        createProductUnit(title: $title) {
          messages
        }
      }
    `,
  },
};

export default schema;
